namespace Solovis.Reports.Parts.Tables.DataTableHelpers.TableModel {
    /*
     * TableModel contains helpers for working with the table model rows and columns.
     */

    export function flattenVisibleRows(sourceRows, flattenOptions) {
        /// <summary>
        /// flattenVisibleRows will flatten the visible rows into containers that have the row (or group row) and level depth,
        /// so that we can easily see the complete list of visible rows (and in the future, support virtual scrolling).
        /// sourceRows will be hierarchical in nature, where groups have references to child rows.
        /// flattenOptions can have { aggregateRowDisplay: "inline/top/bottom", isExpandedCallback: function(nestedGroupKey) { returns true/false },
        ///   keepGroupSubRowsOnCollapse: true/false }
        /// </summary>

        var rowList = [];

        var aggregateDisplay = flattenOptions.aggregateRowDisplay ? flattenOptions.aggregateRowDisplay : "top";
        var isExpandedCallback = flattenOptions.isExpandedCallback ? flattenOptions.isExpandedCallback : function () { return true };
        const keepGroupSubRowsOnCollapse = flattenOptions.keepGroupSubRowsOnCollapse ? true : false;

        if (flattenOptions.tableSettingsToUse && flattenOptions.tableSettingsToUse.aggregateRowDisplay) {
            aggregateDisplay = flattenOptions.tableSettingsToUse.aggregateRowDisplay;
        }

        TableModel._flattenVisibleRowsHelper(sourceRows, rowList, 0, null, aggregateDisplay, isExpandedCallback, keepGroupSubRowsOnCollapse);

        return rowList;
    };

    export function _flattenVisibleRowsHelper(sourceRowList, targetRowList, level, parentRowData, aggregateDisplay, isExpandedCallback, keepGroupSubRowsOnCollapse?) {
        if (sourceRowList) {
            $(sourceRowList).each(function (rowIndex, row: any) {
                var aggregateDisplayToUse = aggregateDisplay;
                if (row._subRowReplacement) {
                    // We always use inline aggregates when processing a row created by subrow processing.
                    aggregateDisplayToUse = "inline";
                }

                if (row._groupId) {
                    var rowData: any = {
                        parentRow: parentRowData,
                        row: row,
                        level: level,
                        inlineAggregates: aggregateDisplayToUse == "inline",
                        isGroupHeader: true
                    };

                    var nestedGroupKey = row._nestedGroupKey;
                    rowData.nestedGroupKey = nestedGroupKey;

                    targetRowList.push(rowData);

                    var aggregateRowData = null;
                    if (aggregateDisplayToUse == "top" || aggregateDisplayToUse == "bottom") {
                        aggregateRowData = {
                            parentRow: parentRowData,
                            row: row,
                            level: level,
                            isAggregateRow: true
                        };
                    }

                    if (aggregateDisplayToUse == "top" && (row._groupTotals || row._backingRow)) {
                        targetRowList.push(aggregateRowData);
                    }

                    // The grouping line's own sub-rows (e.g. its benchmark/excess-return rows) stay
                    // visible even when the group is collapsed. They live on _backingSubRows rather
                    // than _rows so that only the group's detail rows are gated behind expansion.
                    if (keepGroupSubRowsOnCollapse && row._backingSubRows) {
                        TableModel._flattenVisibleRowsHelper(row._backingSubRows, targetRowList, level + 1, rowData, aggregateDisplayToUse, isExpandedCallback, keepGroupSubRowsOnCollapse);
                    }

                    // Flatten child rows.
                    if (row._rows) {
                        if (isExpandedCallback(nestedGroupKey)) {
                            rowData.expanded = true;

                            TableModel._flattenVisibleRowsHelper(row._rows, targetRowList, level + 1, rowData, aggregateDisplayToUse, isExpandedCallback, keepGroupSubRowsOnCollapse);
                        }
                        else {
                            rowData.expanded = false;
                        }
                    }

                    if (aggregateDisplayToUse == "bottom" && (row._groupTotals || row._backingRow)) {
                        targetRowList.push(aggregateRowData);
                    }
                }
                else {
                    var rowData: any = {
                        parentRow: parentRowData,
                        row: row,
                        level: level
                    };

                    targetRowList.push(rowData);
                }
            });
        }
    };


    export function processSubRowFactory(tableControl, processedRows, subRowFactory, subRowGroupKeyGetter, keepGroupSubRowsOnCollapse?) {
        TableModel._processSubRowFactoryForLevel(tableControl, processedRows, subRowFactory, subRowGroupKeyGetter, 0, null, keepGroupSubRowsOnCollapse);
    };

    export function _processSubRowFactoryForLevel(tableControl, processedRows, subRowFactory, subRowGroupKeyGetter, level, parentNestedGroupKey, keepGroupSubRowsOnCollapse?) {
        $(processedRows).each(function (i, row: any) {
            if (row._rows) {
                // Processing sub rows for group row.
                if (row._backingRow) {
                    var backingSubRows = subRowFactory.call(tableControl, row._backingRow);
                    if (!_.isEmpty(backingSubRows)) {
                        $(backingSubRows).each(function (j, subRow: any) {
                            subRow._subRowReplacement = true;
                        });
                        var replacementRow: any = { _backingRow: row._backingRow };
                        replacementRow._groupKey = row._groupKey;
                        replacementRow._nestedGroupKey = row._nestedGroupKey;
                        replacementRow._groupId = row._groupId;
                        if (keepGroupSubRowsOnCollapse) {
                            // Keep the grouping line's own sub-rows separate from its detail rows so
                            // they can stay visible when the group is collapsed (see _flattenVisibleRowsHelper).
                            replacementRow._backingSubRows = backingSubRows;
                            replacementRow._rows = row._rows;
                        }
                        else {
                            replacementRow._rows = backingSubRows.concat(row._rows);
                        }

                        // Place in original slot in processedRows.
                        processedRows[i] = replacementRow;
                    }
                }
                TableModel._processSubRowFactoryForLevel(tableControl, row._rows, subRowFactory, subRowGroupKeyGetter, level + 1, row._nestedGroupKey, keepGroupSubRowsOnCollapse);
            }
            else {
                var subRows = subRowFactory.call(tableControl, row);
                if (!_.isEmpty(subRows)) {
                    var groupKey = subRowGroupKeyGetter(row);
                    var nestedGroupKey;
                    if (parentNestedGroupKey) {
                        nestedGroupKey = parentNestedGroupKey + "||" + groupKey;
                    }
                    else {
                        nestedGroupKey = groupKey;
                    }

                    var replacementRow: any = { _subRowReplacement: true, _backingRow: row };
                    replacementRow._groupKey = groupKey;
                    replacementRow._nestedGroupKey = nestedGroupKey;
                    replacementRow._groupId = "subRowFactory";
                    replacementRow._rows = subRows;

                    // Place in original slot in processedRows.
                    processedRows[i] = replacementRow;
                }
            }
        });
    };
}
